/*

File handles all api calls for dropzone


*/
import React from 'react'
import ReactDOM from 'react-dom';

import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from './modal'

var DropZone = Class.create({
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
        this.dropZone = null;
        this.dynamicUpdate = false;
        this.onSuccessCallback = null;
        this.filesAdded = false;
        this.uploadSuccess = false;
        /**
        *
        * different configurable options. 
        * See: https://github.com/felixrieseberg/React-Dropzone-Component
        */
        this.dropZoneConfig = {
            iconFiletypes: ['.jpg', '.png', '.pdf'],
            showFiletypeIcon: true,
            postUrl: ''
        };
        this.dropZoneJSConfig = {
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: false,
            maxFilesize: 5,
            maxFiles: 1,
            withCredentials: true,
            headers: {
                'Cache-Control': null,
                'X-Requested-With': null,
            }
        }
        this.dropZoneEventHandlers = {
            init: this.dropZoneInit.bind(this),
            addedfile: this.addedfile.bind(this),
            processing: this.processing.bind(this),
            sending: this.sending.bind(this),
            complete: this.complete.bind(this),
            uploadprogress: this.uploadprogress.bind(this),
            success: this.success.bind(this),
            error: this.error.bind(this),
            removedfile: this.removedfile.bind(this),
        }
	},
    dropZoneInit: function(obj) {
        if(this.dropZone !== undefined && obj === undefined) {
        } else {
            this.dropZone = obj;
        }
    },
    addedfile: function(file){
        // weird issue on profile with both compna ylogo and profile options
        if (this.dropZone.files.length == 0 && file !== undefined) {
            this.dropZone.files = [file];
        }
        this.filesAdded = true;
        this.uploadSuccess = false;
        if(file === undefined) {
            return;
        }
        if(file.type != 'application/pdf' && file.type != 'image/jpeg' && file.type != 'image/png') {
            modal.showInfo("Invalid File Type! You can only upload a file of type .jpg, .png, and .pdf", "warning", "top", "center");
            this.dropZone.removeFile(file);
        }
    },
    removedfile: function(file){
        this.filesAdded = false;
    },
    sending: function(file){
    },
    success: function(file, response) {
        if (this.uploadType == "new_lease") {
            modal.showSuccess("Lease Added!","You can now move tenants in!");
            jQuery(".move-on").on('click',function() {
                browserHistory.goBack();
            });
        } else if (this.uploadType == "new_tenant") {
            modal.showSuccess("Tenant Added!","This tenant has been successfully created.");
            jQuery(".move-on").on('click',function() {
                browserHistory.goBack();
            });
        } else if (this.uploadType == "new_listing") {
            modal.showSuccess("Listing Added!","This listing has been successfully created.");
            jQuery(".move-on").on('click',function() {
                browserHistory.goBack();
            });
        } else if (this.uploadType == "new_request") {
            modal.showSuccess("Work Order Added!","This work order has been successfully added.");
            jQuery(".move-on").on('click',function() {
                browserHistory.goBack();
            });
        } else if (this.uploadType == "new_warranty") {
            modal.showSuccess("Warranty Added!","This warranty has been successfully added.");
            jQuery(".move-on").on('click',function() {
                browserHistory.goBack();
            });
        } else if (this.uploadType == "logo") {
            modal.showSuccess("Logo Uploaded!","Your company logo has been successfully uploaded. Please refresh the page to see the change.");
        } else if (this.uploadType == "new_property") {
            modal.showSuccess("Property Added!","This property has been successfully added.");
            jQuery(".move-on").on('click',function() {
                browserHistory.goBack();
            });
        } else if (this.uploadType == "new_vendor_bill") {
            modal.showSuccess("Successfully Created!","A bill has been created!");
            jQuery(".move-on").on('click',function() {
                browserHistory.goBack();
            });
        }

        this.uploadSuccess = true;

        if(this.onSuccessCallback) {
            this.onSuccessCallback();
        }
    },
    error: function(file, message) {
        if(file === undefined) {
            return;
        }
        if (message == "You can not upload any more files.") {
            modal.showInfo("You can only upload 1 file. Remove the previous file to add a new one.", "warning", "top", "center");
        } else {
            modal.showInfo(message, "warning", "top", "center");
        }
        this.dropZone.removeFile(file);
    },
    complete: function(file){
    },
    uploadprogress: function(file){
    },
    // #  Used to dynamically update url
    processing: function(file) {
        if(!this.dynamicUpdate){return;}

        this.dropZone.options.url = this.dropZoneConfig.postUrl;
    },
    isFilesAdded: function() {
        return this.filesAdded
    },
    isUploadSuccess: function() {
        return this.uploadSuccess
    },
    /**
    *
    * When called, uploads all files in queue
    *
    */
    upload: function(type, callback){
        this.uploadType = type;
        this.onSuccessCallback = callback;
        this.dropZone.processQueue();
    },
    /**
    *
    * Configure context with appropriate settings to send into the
    * DropZoneComponent
    */
    setup: function(context, uploadFor = 'tenant', uploadID, dynamicUpdate = false){
        if(uploadID === undefined)
        {
            uploadID = context.props.tenantID;
        }

        // #  Turn on dynamic update
        if(dynamicUpdate) {
            this.dynamicUpdate = true;
        }
        this.onSuccessCallback = null;
        this.dropZoneConfig.postUrl = process.env.APPLICATION_URL + 'upload/' + uploadFor + '/' + uploadID;
		context.setState({
            dropZoneSetup: true,
            dropZoneConfig: this.dropZoneConfig,
            dropZoneJSConfig: this.dropZoneJSConfig,
            dropZoneEventHandlers: this.dropZoneEventHandlers
        });
    },
    overridePostUrl: function(uploadFor, uploadID) {
        this.dropZoneConfig.postUrl = process.env.APPLICATION_URL + 'upload/' + uploadFor + '/' + uploadID;
        this.dropZone.options.url   = process.env.APPLICATION_URL + 'upload/' + uploadFor + '/' + uploadID;
    }
});

export let dropZone = new DropZone();


// WEBPACK FOOTER //
// app/core/utilities/DropZoneHandler.js